export enum ComponentId {
  CIRCUMSTANCES_DATE = "date",
  CIRCUMSTANCES_HOUR = "hour",
  CIRCUMSTANCES_PLACE = "place",
  CIRCUMSTANCES_CITY = "city",
  CIRCUMSTANCES_ZIP_CODE_PL = "zipCodePL",
  CIRCUMSTANCES_ZIP_CODE_GENERIC = "zipCodeGeneric",
  CIRCUMSTANCES_COUNTRY = "country",
  CIRCUMSTANCES_PROVINCE = "province",
  CIRCUMSTANCES_WAS_VEHICLE_IN_MOTION = "wasInMotion",
  CIRCUMSTANCES_DESCRIPTION = "description",
  CIRCUMSTANCES_WAS_DRIVER = "driver",
}
